module.exports = __webpack_public_path__ + "7ce1928f332d47854a939e636ba78aff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/3.svg
// module id = 698
// module chunks = 0